Namespace 'AccountSettings.OperatorStatus'

class AccountSettings.OperatorStatus.OperatorStatusDefaultView extends Backbone.View
  template: JST["backbone/templates/account_settings/operator_statuses/operator_status_default"]

  events:
    "click .default-status-check": "onDefaultCheck"

  initialize: (options) ->
    @checkboxID = options.id
    @enabled = false
    @nulled = false
    super

  render: =>
    @$el.html(@template(checkboxID: @checkboxID, enabled: @enabled, nulled: @nulled))
    @$el.find(".default-status-tooltip")
    @delegateEvents()
    @

  onDefaultCheck: =>
    @setCheckState(!@enabled)
    @render()

  setCheckState: (state) =>
    @enabled = state

  setNullStatus: (state) =>
    @nulled = state

  hide: =>
    @$el.addClass('d-none')

  show: =>
    @$el.removeClass('d-none')
